module.exports = __webpack_public_path__ + "media/images/athletes/2463-ca6fa006db147b68c39f97eae6f11809.png";